import {useMemo} from "react";
import {shallowEqual, useSelector} from "react-redux";
import {State} from "../../redux/store";
import {authClaims} from "./useUserPermissions.constants";
import {AuthPermissions, PermissionClaim} from "./useUserPermissions.types";

/**
 * Права текущего пользователя в модуле авторизации
 */
export const useUserPermissions = (): AuthPermissions => {
  const userClaims = useSelector(
    (state: State) => state.auth.data.userClaims,
    shallowEqual
  );

  return useMemo(() => getAllPermissions(userClaims), [userClaims]);
};

/**
 * Получение объекта прав по клеймам
 */
export const getAllPermissions = (userClaims?: PermissionClaim[]): AuthPermissions => {
  const hasAccountsAccess = getAccessByClaims(userClaims, authClaims.accounts);

  return {
    moduleAccess: hasAccountsAccess,
    accounts: hasAccountsAccess,
    clients: getAccessByClaims(userClaims, authClaims.clients),
    impersonateUser: getAccessByClaims(userClaims, authClaims.impersonateUser),
    getUserById: hasAccountsAccess || getAccessByClaims(userClaims, authClaims.getUserById)
  };
};

const getAccessByClaims = (
  userClaims?: PermissionClaim[],
  claimsToCheck?: PermissionClaim[]
): boolean => {
  return !!userClaims
    && userClaims.some(
      (claim) => claimsToCheck?.some(
        (claimToCheck) => claimToCheck.type === claim.type && claimToCheck.value === claim.value
      )
    );
};
